<script>
export default {
    computed: {
        years() {
            const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(new Date());
            return `2024–${year}`
        }
    }
}</script>

<template>
    <p class="text-sm">Copyright &copy; {{ years }}. BizzyNate Creative, Inc. All Rights Reserved.</p>
</template>